<template>
		<div>
	<div
	  ref="videoSearchContent"
	  style="display: flex; justify-content: right; align-items: flex-start; width: 100%; height: 71vh; gap: 10px;"
	>
	<!-- Video Container -->
	  <div class="video-container mt-1" v-if="videoUrl" style="flex: 2;">	  	
			<!-- Video -->
			<video
			  	:src="videoUrl"
			  	:crossorigin="corsStrategy"
			  	class="video-element"
			  	ref="videoElement"
			  	@loadeddata="onVideoLoaded"
			  	@timeupdate="updateProgress"
			  	@error="onVideoError"
			  	@waiting="onBuffering"
        		@playing="onPlaying"
			  	playsinline
			  	preload="metadata"
			>
		  		{{ $ml.get('browser_not_support_video') }}
			</video>
			
			<!-- Canvas -->
			<DrawOnVideo v-if="isVideoLoaded && isCropVideo" :refVideo="$refs.videoElement" :refContent="$refs.videoSearchContent" :infoToFilter="infoToFilter" @captureImage="capturedImage=$event" :progressTime="progress"></DrawOnVideo>
			<canvas v-if="isVideoLoaded" ref="drawRect" class="overlay-canvas-draw-1" ></canvas>

			<div class="video-controls">
				<v-btn-toggle class="play-btn">
				<v-tooltip bottom>
      				<template v-slot:activator="{ on, attrs }">
			    		<v-btn color = "primary"  @click="togglePlayPause" v-bind="attrs" v-on="on">
					      <v-icon>{{ isPlaying ? "mdi-stop" : "mdi-play" }}</v-icon>
					    </v-btn>
					</template>
      				<span>{{ isPlaying ? $ml.get('pause') : $ml.get('play') }}</span>
    			</v-tooltip>
				<v-tooltip bottom>
      				<template v-slot:activator="{ on, attrs }">					    
			    		<v-btn :color="isCropVideo?'primary':'secondary'"  @click="isCropVideo=!isCropVideo" v-bind="attrs" v-on="on">
					      <v-icon>mdi-crop</v-icon>
					      <!-- crop video -->
					    </v-btn>
					    </template>
      				<span>{{ isCropVideo? $ml.get('disableCropImage') : $ml.get('enableCropImage')  }}</span>
    			</v-tooltip>
				<v-tooltip bottom>
      				<template v-slot:activator="{ on, attrs }">
					    <v-btn :color="'success'" :loading="loading" :disabled="!isCropVideo" @click="captureClipping()" v-bind="attrs" v-on="on">
					      <v-icon>mdi-camera</v-icon>
					      <!-- crop video -->
					    </v-btn>
					    </template>
      				<span>{{ $ml.get('cropImage') }}</span>
    			</v-tooltip>

			    <v-btn text plain tile disabled >
			    	<span>{{ formatTime(progress) }} / {{ formatTime(maxDuration) }}</span>
			    </v-btn>
				</v-btn-toggle>
		    <v-slider
		    	v-model="progress"      
			    height="10"       
			    color="blue"
			    class="progress-bar"
			    min="0"
			    :max="maxDuration"      
			    @change="seekVideo"
			    loader-height="20"
			    step="0.1"
		    ></v-slider>
		    
		  </div>
		  
		  <!-- Chart Section -->
		  <v-row no-gutters v-show="imgLine && showLineChart" class="content-linechart-video mt-1">
		  	<v-col cols="auto">
			   	<div style="height: 100%; width: 147px; text-align: center;">
					<img						        				
			    		:src   = "imgLine" 
		         		@error = "imgLine = '/img/no_img_found.png'"
		         		:width  = "145" 
		         		:height = "'150'"
		            	crossorigin=""
	    			/>
    				<span> {{ $ml.get('face_selected') }} </span>	    				
				</div>	
  			</v-col>
  			<v-col cols="auto ml-1">
            	<div style="height: 100%; width: 147px; text-align: center;">
					<img						        				
		    			:src   = "currentImage" 
		         		@error = "currentImage = '/img/no_img_found.png'"
		         		:width  = "145" 
		         		:height = "'150'"
	            		crossorigin=""
	    			/>
	              	<span> {{$ml.get('video_clipping')}} </span>
	            </div>
	    		<v-progress-linear
	                indeterminate
	                color="cyan"
	                :active="loadingCrop"
	            ></v-progress-linear>
  			</v-col>
    		    	<v-col>				            			        	
				<div class="chart-container">
		        	<canvas ref="lineChartVideo" class="chart-draw"></canvas>
		      	</div>
    		</v-col>
    	</v-row>
    	
	  		<!-- <span>{{infoData}}</span> -->
	  </div>
	  
	  <!-- Information Column -->
	  <div class="info-column" v-if="imgLine && showLineChart" style="flex: 1; max-width: 400px; height: 100%; overflow-y: auto;">
	  	<!-- Información adicional del frame -->
	  	<v-card outlined class="pa-2 mb-2" style="height: auto;">
	  		<v-card-title class="subtitle-1 pa-2">
	  			{{ $ml.get('frame_information') }}
	  		</v-card-title>
	  		<v-card-text class="pa-2">
	  			<v-row dense>
	  				<v-col cols="12">
	  					<v-row dense>
	  						<v-col cols="12">
	  							<strong>{{ $ml.get('similarity') }}:</strong> 
	  							{{ getCurrentSimilarity() }}%
	  						</v-col>
	  						<v-col cols="12">
	  							<strong>{{ $ml.get('time') }}:</strong> 
	  							{{ getCurrentTime() }}
	  						</v-col>
	  						<v-col cols="12" v-if="getCurrentFrameData()">
	  							<strong>{{ $ml.get('timestamp') }}:</strong> 
	  							{{ formatTimestamp(getCurrentFrameData().timestamp) }}
	  						</v-col>
	  						<v-col cols="12" v-if="getCurrentFrameData() && getCurrentFrameData().bbox">
	  							<strong>{{ $ml.get('bbox') }}:</strong> 
	  							x: {{ (getCurrentFrameData().bbox.x * 100).toFixed(1) }}%, 
	  							y: {{ (getCurrentFrameData().bbox.y * 100).toFixed(1) }}%
	  						</v-col>
	  						<v-col cols="12" v-if="getCurrentFrameData() && getCurrentFrameData().frame_idx">
	  							<strong>{{ $ml.get('frame_index') }}:</strong> {{ getCurrentFrameData().frame_idx }}
	  						</v-col>
	  						
	  						<v-col cols="12" v-if="getCurrentFrameData() && getCurrentFrameData().faceId">
	  							<strong>{{ $ml.get('face_id') }}:</strong> {{ getCurrentFrameData().faceId.substring(0, 8) }}...
	  						</v-col>
	  						<v-col cols="12" v-if="getCurrentFrameData() && getCurrentFrameData().photo_uuid">
	  							<strong>{{ $ml.get('photo_uuid') }}:</strong> {{ getCurrentFrameData().photo_uuid.substring(0, 8) }}...
	  						</v-col>
	  						<v-col cols="12" v-if="getCurrentFrameData() && getCurrentFrameData().infovideo">
	  							<strong>{{ $ml.get('video_info') }}:</strong>
	  							<div class="ml-4">
	  								<div><strong>{{ $ml.get('fps') }}:</strong> {{ getCurrentFrameData().infovideo.fps }}</div>
	  								<div><strong>{{ $ml.get('resolution') }}:</strong> {{ getCurrentFrameData().infovideo.frameWidth }}x{{ getCurrentFrameData().infovideo.frameHeight }}</div>
	  								<div><strong>{{ $ml.get('total_frames') }}:</strong> {{ getCurrentFrameData().infovideo.total_frames }}</div>
	  								<div><strong>{{ $ml.get('total_faces') }}:</strong> {{ getCurrentFrameData().infovideo.total_faces }}</div>
	  							</div>
	  						</v-col>
	  					</v-row>
	  				</v-col>
	  				
	  				<!-- Columna de la foto completa -->
	  				<v-col cols="12" v-if="getCurrentFramePhoto()">
	  					<div class="text-center">
	  						<strong>{{ $ml.get('full_frame') }}:</strong>
	  						<div class="mt-2">
	  							<img 
	  								:src="getCurrentFramePhoto()" 
	  								style="border: 1px solid #ccc; border-radius: 4px; width: 100%; height: auto; max-height: 200px; object-fit: contain;"
	  								@error="handleImageError"
	  							/>
	  						</div>
	  					</div>
	  				</v-col>
	  			</v-row>
	  		</v-card-text>
	  	</v-card>
	  </div>
	  <div class="video-container" v-else   style="flex: 3;">
		<!-- Video -->
		<video
		  :src="$logos.no_signal"
		  controls
		  class="video-element-1"
		>
		  <meta itemprop="thumbnail" :content="$logos.mark || ($vuetify.theme.dark ? $logos.login_night : $logos.login)" />
		  {{ $ml.get('browser_not_support_video') }}
		</video>
		<!-- Canvas -->
		<canvas
		  ref="overlayCanvas"
		  class="overlay-canvas"
		></canvas>
	  </div>
  		<v-card elevation="2" class="info-card ml-2" style="flex: 2; max-width:450px; height: 100%; ">
	    	<v-card-title>{{$ml.get('cuts')}}</v-card-title>
		    <v-card-text style="max-height:90%; height:80%; overflow-y: auto;">
		      <!-- Contenido de la sección -->
		      <v-row dense >		      	
			      	<template v-for="(itemCup, index) in listCups">
				      	<v-col cols="5" :key="index">				      		
					      	<v-row no-gutters>
					      		<v-col cols="12">					      			
							      	<v-sheet :color="itemCup.isValid?'success':'error'" width="158" height="158" class="pa-1">		      		
								      	<img
								      		:src="itemCup.imgCup"
								      		@error = "itemCup.imgCup = '/img/no_img_found.png'"
							         		:width  = "150" 
							         		:height = "'150'"
						            		crossorigin=""
								      	>
							      	</v-sheet>
					      		</v-col>
					      		<v-col cols="9 mt-2"  >
					      			<strong>{{ itemCup.name }}</strong> 
					      		</v-col>
					      		<v-col cols="2">
							      	<v-btn  icon @click="$Helper.downloadImage(itemCup.imgCup, `${itemCup.name}.png`)">
							      		<v-icon >mdi-download</v-icon>
							      	</v-btn>
					      		</v-col>
					      		<v-col cols="12">					      			
					      			<span>{{ itemCup.msg }}</span>
					      		</v-col>
					      	</v-row>
				      	</v-col>
				    </template>
		      	</v-row>
		    </v-card-text>
	  	</v-card>
	</div>
	
	</div>
  </template>


<script type="text/javascript">
	import DrawOnVideo from "@/components/face/DrawOnVideo.vue"
	import { Chart } from "chart.js";
	import  Chartt from "chart.js";
	import VideoProcessor from "@/class/VideoProcessor.js"

	import 'chartjs-plugin-annotation';
	import zoomPlugin from 'chartjs-plugin-zoom';
	// Chart.register(zoomPlugin);
	Chartt.plugins.register(zoomPlugin);

	// import annotationPlugin from 'chartjs-plugin-annotation';
	// import VideoControls from "@/components/face/VideoControlsSearch.vue"
	export default{
		name : "VideoSearchByVideo",
		components:{DrawOnVideo},
		props : ["videoUrl", "currentHeight", "infoToFilter", "isDialogOpen", "Threshold"],
		data:()=>({
			isVideoLoaded:false,
			isPlaying: false,
	  		progress: 0,
	  		maxDuration : 0,
	  		isCropVideo: false,
	  		capturedImage:null,
	  		loading: false,
	  		clearRect:null,
	      	chart: null,
	  		imgLine: null,
	  		infoData : null,
	  		listTimes:[],
	  		currentImage: null,
	      	timeoutCrop : null,
	      	listCups : [],
	      	showLineChart: false,
	      		  		currentTimeMS: 0,
	      	lastVideo : "",
	      	loadingVideo : true,
	      	textLoadingVideo : "loading",
      		loadingCrop:false,
      		corsStrategy: null, // Will be set dynamically
      		currentFrameData: null, // Datos del frame actual
      		currentSimilarity: 0, // Similitud actual
      		currentTime: null, // Tiempo actual
  		 // { isVideoLoaded:false,"userId": "1599", "photo_uuid": "f193edf5-fba4-4f22-a6c9-c01c71b00d55", "bbox": { "x": 0.28103, "y": 0.270833, "w": 0.433255, "h": 0.533333 }, "faceId": 1596, "similarity": 0.107205, "path": "/alert/2024/12/6/1735399121243/1735399121243_photo.jpg", "frame_idx": "1599", "infovideo": { "id": 8, "fps": 24, "frameHeight": 480, "frameWidth": 854, "requestUuid": "f64905fb-3af8-48c3-9736-ee20269e17cd", "status": "200", "total_faces": 700, "total_frames": 3590, "path": "/opt/alice-media/faces/file-1735358497969-WhatsApp_Video_2024-12-20_last.mp4", "url": "/faces/file-1735358497969-WhatsApp_Video_2024-12-20_last.mp4", "createdAt": "2024-12-28T04:02:51.269Z", "updatedAt": "2024-12-28T04:02:51.269Z" }, "currentTime": 66.625 } 
		}),
		mounted(){
			
			this.textLoadingVideo="loading";		
			if(!this.lastVideo){
				this.lastVideo=this.videoUrl;										
      			
			}
		},
		beforeDestroy() {
	    if (this.chart) {
	      this.chart.destroy();
	    }
		
		if (this.listCups && this.listCups.length > 0) {
			this.listCups.forEach(cup => {
				if (cup.imgCup && cup.imgCup.startsWith('blob:')) {
					URL.revokeObjectURL(cup.imgCup);
				}
			});
		}
  	},
		watch:{
			"infoToFilter.selectedVideoDialog"(val, old){
				
				if(this.isVideoLoaded && val){
					// Actualizar información del frame cuando se selecciona un nuevo punto
					this.updateFrameInfoFromSelectedDialog(val);
				}
			},
			isDialogOpen(val){
				this.listCups=[];
				if(!val){
					this.pauseVideo();
					this.clearCanvas();
			    	this.isVideoLoaded=false;

					// if (this.chart) {
			    //   this.chart.destroy();
			    // }
				}else{
					this.textLoadingVideo="loading";
					this.loadingVideo=true;
		      		

					 
					if(this.lastVideo==this.videoUrl){
						
						this.loadingVideo=false;
		      			
					}else{
						this.lastVideo=this.videoUrl
					}
					this.initializeVideo();
					
					// Inicializar información del frame si está disponible
					if (this.infoToFilter?.selectedVideoDialog) {
						this.$nextTick(() => {
							this.updateFrameInfoFromSelectedDialog(this.infoToFilter.selectedVideoDialog);
						});
					}
				}
			},
			Threshold(){
			 
			  this.chart.options.scales.yAxes[0].ticks.min =parseInt(Math.abs(this.Threshold)*100);
			  this.chart.update();
			}
		},
		methods:{
			onVideoLoaded() {
			   
			    this.isVideoLoaded=true;
			    this.initializeVideo();
			    this.loadingVideo=false;
		      	

			    // Asegurar que se inicialice la información del frame cuando el video esté cargado
			    if (this.infoToFilter?.selectedVideoDialog) {
			        this.updateFrameInfoFromSelectedDialog(this.infoToFilter.selectedVideoDialog);
			    }
		  	},
		  	onBuffering() {
		      	this.textLoadingVideo="waiting_for_data" 
		      	this.loadingVideo = true;
		      	
		    },
		    onPlaying() {
		      	this.loadingVideo = false;
		      	this.textLoadingVideo="loading" 
		      	
		    },
		  	onVideoError(event) {
		      	this.loadingVideo = false;
				this.textLoadingVideo="error_loading";
		      	
		      	// Try to handle CORS errors
		      	const error = event.target.error;
		      	if (error && error.code === MediaError.MEDIA_ERR_SRC_NOT_SUPPORTED) {
		      		
		      		this.corsStrategy = null;
		      		this.$refs.videoElement.crossOrigin = null;
		      		this.$refs.videoElement.load();
		      	}
		    },
		  	clearCanvas(){
		  		if(this.infoClear){
					this.infoClear.ctx.clearRect(0,0,this.infoClear.width,this.infoClear.height);
					this.infoClear=null;
				}
				// this.updateChart([], [])
				this.showLineChart=false;
		  	},
			renderDraw(){
				const item=this.infoToFilter?.selectedVideoDialog ;				
				if(this.progress && item && item?.bbox && this.isVideoLoaded){
					const currentTime=item?.currentTime 					
					const itemList=(currentTime >= this.progress && currentTime <= (this.progress + 0.05)) ? item : 
						this.listTimes && this.listTimes.length? item.facesSelected.find(x=> (x.currentTime>=this.progress && x.currentTime<=(this.progress+0.05))) : 
						false;

					
					if(itemList){
						// Actualizar datos del frame actual para la información adicional
						this.currentFrameData = {
							bbox : itemList?.bbox,
							progress : this.progress,
							bbox_prob : itemList?.bbox_prob,
							currentTime : itemList?.currentTime,
							faceId : itemList?.faceId,
							frame_idx : itemList?.frame_idx,
							id : itemList?.id,
							infovideo : itemList?.infovideo,
							path : itemList?.path,
							photo_uuid : itemList?.photo_uuid,
							similarity : itemList?.similarity,
							timestamp : itemList?.timestamp,
						};
						
						// Actualizar similitud y tiempo actual
						this.currentSimilarity = (itemList?.similarity * 100).toFixed(2);
						this.currentTime = this.formatTimeToMMSS(itemList?.currentTime);
						const canvas = this.$refs.drawRect;
				        const ctx = canvas.getContext("2d");
				        if(ctx){
				          	const video = this.$refs.videoElement;		          
				        	canvas.style.height=video.offsetHeight+'px';//video.offsetHeight ? video.offsetHeight : video.height ? video.height : canvas.height; 
				        	canvas.height=video.offsetHeight
				        	
				          	let element= itemList;

				          	let fx = element.bbox.x *  parseInt(video.width || canvas.width) ;
				          	let fy = element.bbox.y *  parseInt(video.height || canvas.height);
				          	let w  = element.bbox.w *  parseInt(video.width || canvas.width);
				          	let h  = element.bbox.h *  parseInt(video.height || canvas.height);
				          	
				          
				          	
				          	fx = Math.abs(fx)
				          	fy = Math.abs(fy)
				          
				          
				          	
				          	this.infoClear={ ctx, width: canvas.width, height : canvas.height }
				          	ctx.clearRect(0, 0, canvas.width, canvas.height); // Limpia el canvas
				          	ctx.strokeStyle = "red";
				          	ctx.lineWidth = 1;
				          	ctx.strokeRect(fx, fy, w, h); // fill		          
		          		

			          		const canvasCrop = document.createElement("canvas");
					        	// canvasCrop.style.height=video.offsetHeight+'px';//video.offsetHeight ? video.offsetHeight : video.height ? video.height : canvas.height; 
					        	// canvasCrop.height=video.offsetHeight
					        	// canvasCrop.style.height=video.offsetHeight+'px';
					        	
			          		// const scaleX = video.offsetWidth / video.videoWidth;
										// const scaleY = video.offsetHeight / video.videoHeight;

			          		// canvasCrop.width = canvas.width//w * scaleX;
			          		// canvasCrop.height = video.offsetHeight//h * scaleY;

			          		let fdx = element.bbox.x *  parseInt(video.videoWidth) ;
				          	let fdy = element.bbox.y *  parseInt(video.videoHeight);
				          	let wd  = element.bbox.w *  parseInt(video.videoWidth);
				          	let hd  = element.bbox.h *  parseInt(video.videoHeight);
				          	
			          		const scaleFactor = 1.01; // Aumenta la resolución del canvas
			          		canvasCrop.width = wd * scaleFactor; 
			          		canvasCrop.height = hd * scaleFactor; 
			          		
			          		const ctxCrop = canvasCrop.getContext("2d", { willReadFrequently: true });
					         
					       	ctxCrop.imageSmoothingEnabled = true;
			          		ctxCrop.imageSmoothingQuality = "high";
			          		try{
				            	ctxCrop.drawImage(
					              video,
					              fdx,
					              fdy,
					              wd,
					              hd,
					              0, 0, wd, hd
				              	);
								
				          	}catch(error){
				            	
				          	}finally{
					            // clearTimeout(this.timeoutCrop);
					            // this.timeoutCrop=null;
					            // video.removeEventListener("seeked", this.captureFrame);
				          	}
				        }
					}else if(this.infoClear){
						this.infoClear.ctx.clearRect(0,0,this.infoClear.width,this.infoClear.height);
						this.infoClear=null;
					}
					
					// Si no hay datos del frame, limpiar la información actual
					if(!itemList) {
						this.currentFrameData = null;
						this.currentSimilarity = 0;
						this.currentTime = null;
					}
				}
				this.loadingCrop=false;
			},
			togglePlayPause() {
		      	this.isPlaying ? this.pauseVideo() : this.playVideo();
		    },
		   
			playVideo() {
				const video = this.$refs.videoElement;
				video.play();
				this.isPlaying = true;
			},
			pauseVideo() {
				const video = this.$refs.videoElement;
				if(video){					
					video.pause();
					this.isPlaying = false;
				}
			},
			seekVideo(newTime) {
				
				const video = this.$refs.videoElement;
				video.currentTime = newTime;
				this.currentTimeMS= newTime;
				if (this.chart && this.chart.options.annotation && this.chart.options.annotation.annotations?.length > 0) {
					this.chart.options.annotation.annotations[0].value = this.currentTimeMS;

					// Solo actualiza si hay datos
					if (this.chart.data.datasets?.[0]?.data?.length > 0) {
						this.chart.update(0);
					}
				}
			},
			updateProgress() {
				const video = this.$refs.videoElement;
				
				if(video){
					this.progress=video.currentTime;
					this.currentTimeMS=this.progress;
					if (this.chart && this.chart.options.annotation && this.chart.options.annotation.annotations?.length > 0) {
						this.chart.options.annotation.annotations[0].value = this.currentTimeMS;

						// Solo actualiza si hay datos
						if (this.chart.data.datasets?.[0]?.data?.length > 0) {
							this.chart.update(0);
						}
					}
					this.renderDraw();
				}
				// this.progress = (video.currentTime / video.duration) * 100;
			},
			initializeVideo() {
				const video = this.$refs.videoElement;
				if(video && video?.duration){
					this.progress = 0;
					this.isPlaying = false;
					this.maxDuration = video.duration

					if(this.infoToFilter.selectedVideoDialog?.currentTime) {
						video.currentTime = this.infoToFilter.selectedVideoDialog.currentTime;
					}
					
					if (this.chart) {
						const { tempLabels, tempData, dataObject } = this.renderDataChart();
				        if(dataObject?.length){
				        	
				        	this.updateChart(tempLabels, dataObject) // tempData
				        }		      
					}else{
						this.createChart();			    
			   		}
					
					// Asegurar que se inicialice la información del frame después de inicializar el video
					if (this.infoToFilter?.selectedVideoDialog && this.isVideoLoaded) {
						this.updateFrameInfoFromSelectedDialog(this.infoToFilter.selectedVideoDialog);
					}
				}else{
					const timer = setTimeout(()=>{
						this.initializeVideo();
						clearTimeout(timer)
					},1000)
				}
				// const canvas = this.$refs.drawRect;
				// canvas.height = video.videoHeight;
			},
			
			updateChart(newLabels, newData) {
		      this.chart.data.labels = newLabels; // Actualizar labels
		      this.chart.data.datasets[0].data = newData; // Modificar datos
		      this.chart.update(); // Refrescar gráfico
		    },
			
			async captureClipping(){
				try{
					this.loading=true;					
					const response = await this.$Helper.validateFaceUpload({ face: this.capturedImage });
					if(response.data?.length > 0){
						const item=response.data[0];
						const newCup = {
							imgCup: this.capturedImage, // Ya es un Object URL
							name: item.name || this.$ml.get("not_found"),
							isValid: item.state,
							msg: item.state ? this.$ml.get("validated") : this.$ml.get("not_validated")
						};
						this.listCups.push(newCup);
						// No se revoca aquí para que se muestre en la lista
					} else {
						// Si no hay datos, se puede revocar la imagen capturada si no se va a usar más
						if (this.capturedImage) {
							URL.revokeObjectURL(this.capturedImage);
							this.capturedImage = null;
						}
					}
				} catch(error) {
					
					// Revocar en caso de error
					if (this.capturedImage) {
						URL.revokeObjectURL(this.capturedImage);
						this.capturedImage = null;
					}
				} finally {
					this.loading = false;
				}
			},
		formatTime(seconds) {
	      	const minutes = Math.floor(seconds / 60);
	      	const secs = Math.floor(seconds % 60);
	    	const milliseconds = Math.floor((seconds % 1) * 1000 /10);
	      	return `${minutes}:${secs < 10 ? "0" : ""}${secs}:${String(milliseconds).padStart(2, "0")}`;
	    },
	    renderDataChart(){
	    	let tempData=[];
	      	let tempLabels=[];
	      	let dataObject=[];
	      	
	      	const durationSec = Math.ceil(this.maxDuration);

	      	// const durationMs = Math.ceil(this.maxDuration); // convertir a milisegundos
	      	// const startTimeMs = 0;
			// const endTimeMs = Math.ceil(durationMs / 60) * 60; // redondear al minuto más cercano hacia arriba
			// const datosPorMinuto = new Map();

	      	if(this.infoToFilter?.selectedVideoDialog && this.infoToFilter?.selectedVideoDialog?.facesSelected && this.infoToFilter?.selectedVideoDialog.facesSelected.length){        
        		/*this.infoToFilter?.selectedVideoDialog.facesSelected.forEach((item)=>{
	          		// tempLabels.push(this.formatTime(parseFloat(item.currentTime.toFixed(2))))
	          		tempData.push((Math.abs(item.similarity)*100).toFixed(2))
	          		const minuto = parseFloat(item.currentTime.toFixed(2));//Math.floor(item.currentTime / 60) * 60;
    				datosPorMinuto.set(minuto, item.similarity);
    				dataObject.push({
    					x: parseFloat(item.currentTime.toFixed(2)),//item.currentTime* 1000, // this.formatTime(parseFloat(.toFixed(2))) 
    					y: parseFloat((Math.abs(item.similarity) * 100).toFixed(2)) //(Math.abs(item.similarity)*100).toFixed(2)
    				})
        		})
		        // Generar puntos cada minuto entre 0 y duración total del video
				let currentTime = startTimeMs;
				while (currentTime <= endTimeMs) {
					if(!datosPorMinuto.get(currentTime)){						
						// tempLabels.push(currentTime*1000)						
						tempData.push(0);
						dataObject.push({x : currentTime, y: 0});
					}

					currentTime += 1;
				}*/
		        // Asignar imagen del rostro seleccionado y datos del frame
		        if(this.infoToFilter?.selectedVideoDialog?.croppedFacePhoto) {
		          	// Usar la imagen del frame capturado si está disponible
		          	this.currentImage = this.infoToFilter.selectedVideoDialog.croppedFacePhoto;
		        }
		        
		        // Inicializar datos del frame actual si están disponibles
		        if(this.infoToFilter?.selectedVideoDialog) {
		          	// Usar el método updateFrameInfoFromSelectedDialog para inicializar correctamente
		          	this.updateFrameInfoFromSelectedDialog(this.infoToFilter.selectedVideoDialog);
		        }
		        
		        if(this.infoToFilter?.selectedVideoDialog?.facesSelected[0]?.infovideo?.url){
		          	this.imgLine=this.$URL+this.infoToFilter?.selectedVideoDialog?.path;//facesSelected[0]?.infovideo?.url;
		        }
	      		const segundosUsados = new Set();

				this.infoToFilter?.selectedVideoDialog.facesSelected.forEach((item) => {
				  const tiempo = parseFloat(item.currentTime.toFixed(2));
				  const segundo = Math.floor(tiempo);
				  segundosUsados.add(segundo);

				  tempData.push((Math.abs(item.similarity) * 100).toFixed(2));
				  dataObject.push({
				    x: tiempo,
				    y: parseFloat((Math.abs(item.similarity) * 100).toFixed(2)),
				  });
				});

				// Completar los segundos faltantes
				for (let s = 0; s <= durationSec; s++) {
				  if (!segundosUsados.has(s)) {
				    dataObject.push({ x: s, y: 0 });
				  }
				}
				
				dataObject=dataObject.sort((a, b) => a.x - b.x);


		        this.listTimes=dataObject//tempData;
 				this.showLineChart=true;
 			}else{
 				this.showLineChart=false;
 				this.imgLine=null;
 			}
 			return { tempData, tempLabels, dataObject};
	    },
	    createChart() {	    	
	      
        const { tempLabels, tempData, dataObject} = this.renderDataChart();
        if(dataObject?.length){
        	


		        this.$nextTick(()=>{
		        
				      const ctx = this.$refs?.lineChartVideo?.getContext("2d");
				      this.chart = new Chart(ctx, {
				        type: "line",
				        data: {
				          // labels: tempLabels,//["00:00", "01:00", "02:00", "03:00", "04:00", "05:00"], // Etiquetas para el eje X (tiempo)
				          datasets: [
				            {
				              label: this.$ml.get("similarity"),
				              data: dataObject, // tempData, //[0.1, 0.4, 0.6, 0.8, 0.5, 0.9], // Datos para el eje Y (probabilidad)
				              borderColor: "rgba(54, 162, 235, 1)",
				              backgroundColor: "rgba(54, 162, 235, 0.2)",
				              borderWidth: 1.5,
				              pointRadius: 3,
				              pointHoverRadius: 5,
				              // pointBackgroundColor: '#42A5F5',  // Color normal del punto
				              // pointHoverBackgroundColor: '#FF5722', // Cambia el color al pasar el mouse
				              // pointBorderColor: '#fff',
				              // pointHoverBorderColor: '#FF5722',
				            },
				          ],
				        },
				        options: {
				          responsive: true,
				          onClick: this.handleClick,
				          maintainAspectRatio: false,
				           onHover: (event, elements) => {	            
				            if (elements.length > 0) {
				              // const datasetIndex = elements[0]._datasetIndex;
				              const dataIndex = elements[0]._index;
				              const hoveredItem = this.infoToFilter?.selectedVideoDialog.facesSelected[dataIndex];
				              
				              if (hoveredItem) {
				                this.loadingCrop=true;
				                this.updateVideo(hoveredItem.currentTime);
				                
				                // Capturar frame del punto hovered
				                //this.captureFrameForHover(hoveredItem);
				              }
				            }
				          },
				          annotation: {
						    annotations: [
						      {
						        type: 'line',
						        mode: 'vertical',
						        scaleID: 'x-axis-0', // ← este debe coincidir con el ID del eje X
						        value: this.currentTimeMS,
						        borderColor: 'red',
						        borderWidth: 2,
						        label: {
						          enabled: true,
						          content: '⏱️',
						          position: 'top'
						        }
						      }
						    ]
	  					},
				        plugins: {
				            tooltip: {
				            	callbacks: {
				                label: function(tooltipItem) {
				                  let value = tooltipItem.raw; // Convierte a porcentaje
				                  return String(value) + '%';
				                }
				              },
				              enabled: true,             
				            },
				            zoom: {
						      zoom: {
						      	enabled: true,
						      	drag: false,
						        wheel: {
						          enabled: true,
						        },
						        pinch: {
						          enabled: true,
						        },
						        mode: 'x',
						      },
						      pan: {
						        enabled: true,
						        mode: 'x',
						      }
						    }
				           /* annotation: {
							    annotations: {
							      	lineaTiempo: {
								        type: 'line',
								        scaleID: 'x',
								        value: this.currentTimeMS, // esto debe actualizarse en tiempo real
								        borderColor: 'red',
								        borderWidth: 2,
								        label: {
									        content: '⏱️',
									        enabled: true,
									        position: 'start'
								        }
							      }
							    }
							}*/
				        },
				          scales: {
				          	 yAxes: [{
				                // ticks: {
				                //     min: Math.abs(this.Threshold)*100, // Establece el mínimo en 5
				                //     // (Opcional) Establece un máximo
				                // }
				               /* ticks: {
							      callback: value => value + '%'
							    }*/

							      ticks: {
							        min: Math.abs(this.Threshold) * 100,
							        callback: function(value) {
							          return String(value.toFixed(0)) + '%';
							        }
							      },
							      scaleLabel: {
							        display: true,
							        labelString: this.$ml.get("similarity")
							      }
							    
				            }],
				            xAxes: [
				            	/*{
							    type: 'time',
							    // ...
							  }*/

				            	{
								    id: 'x-axis-0', // este es el ID por defecto si no lo ponés
					            	type: 'linear',
					            	position: 'bottom',
									ticks: {
									    callback: (value) => {
									      const mins = Math.floor(value / 60);
									      const secs = Math.floor((value % 60));
									      return `${String(mins).padStart(2, '0')}:${String(secs).padStart(2, '0')}`;
									    }
									  },
									scaleLabel: {
									    display: true,
									    labelString: this.$ml.get("time") + " (MM:SS)"
									}
								}
							],
				            /*x: {
				            	// type: 'time',
					              time: {
					                unit: 'second', // o 'second' si querés más granularidad
					                stepSize: 10 // fuerza la separación constante
					              },
					              ticks: {
					                autoSkip: false // muestra todos los ticks
					              },	
				              	title: {
				                	display: true,
				                	text: this.$ml.get("time") + " (HH:MM)", // Título del eje X
				              	},
				            },
				            y: {
				              title: {
				                display: true,
				                text: this.$ml.get("similarity"), // Título del eje Y
				              },
				              ticks: {
					            callback: function(value) {
					              return String(value.toFixed(0)) + '%'; // Convierte a porcentaje
					            }
					          },
				              // min: 0,
				              // max: 1, // Rango de probabilidad (0 a 1)
				            },*/
				          },
				        },
				      });
		        })
			
	     	}
	    },
		updateVideo(time) {
	      if((typeof time !== "number" || isNaN(time)) && !isFinite(time)){
	        
	        return
	      }
			const video = this.$refs.videoElement;
			// Ajusta el tiempo del video al índice del punto en la gráfica
			video.currentTime = time//index * 10; // Por ejemplo, cada punto representa 10 segundos
			this.progress=time;
			this.pauseVideo()
			this.renderDraw();
	      // if (video.paused) video.play();
	      // video.stop()
	    },
	    
	    async captureFrameForHover(item) {
	      try {
	        // Crear un VideoProcessor temporal para capturar el frame
	        const tempVideoProcessor = new VideoProcessor(this.videoUrl, this.$URL);
	        await tempVideoProcessor.load();
	        
	        const result = await tempVideoProcessor.captureFrame(item);
	        
	        // Actualizar la imagen del rostro recortado
	        if (this.currentImage) {
	          URL.revokeObjectURL(this.currentImage);
	        }
	        this.currentImage = result.croppedFacePhoto;
	        
	        // Actualizar datos del frame actual
	        this.currentFrameData = result.originalData;
	        this.currentSimilarity = (item.similarity * 100).toFixed(2);
	        this.currentTime = this.formatTimeToMMSS(item.currentTime);
	        
	        this.loadingCrop = false;
	        
	      } catch (error) {
	        this.loadingCrop = false;
	        
	      }
	    },
	    
	    // Métodos para obtener información del frame actual
	    getCurrentSimilarity() {
	      if (this.currentSimilarity) {
	        return this.currentSimilarity;
	      }
	      if (this.currentFrameData && this.currentFrameData.similarity) {
	        return (this.currentFrameData.similarity * 100).toFixed(2);
	      }
	      return 'N/A';
	    },
	    
	    getCurrentTime() {
	      if (this.currentTime) {
	        return this.currentTime;
	      }
	      if (this.currentFrameData && this.currentFrameData.currentTime) {
	        return this.formatTimeToMMSS(this.currentFrameData.currentTime);
	      }
	      return 'N/A';
	    },
	    
	    getCurrentFrameData() {
	      return this.currentFrameData;
	    },
	    
	    getCurrentFramePhoto() {
	      if (this.currentFrameData && this.currentFrameData.framePhoto) {
	        return this.currentFrameData.framePhoto;
	      }
	      
	      // Fallback: intentar obtener la foto del frame desde selectedVideoDialog
	      if (this.infoToFilter?.selectedVideoDialog?.framePhoto) {
	        return this.infoToFilter.selectedVideoDialog.framePhoto;
	      }
	      
	      return null;
	    },
	    
	    handleImageError(event) {
	      
	      // Opcional: mostrar una imagen de placeholder o mensaje de error
	      event.target.style.display = 'none';
	    },
	    
	    formatTimeToMMSS(seconds) {
	      const minutes = Math.floor(seconds / 60);
	      const remainingSeconds = Math.floor(seconds % 60);
	      return `${minutes.toString().padStart(2, '0')}:${remainingSeconds.toString().padStart(2, '0')}`;
	    },
	    
	    formatTimestamp(timestamp) {
	      if (!timestamp) return 'N/A';
	      return new Date(timestamp).toLocaleString();
	    },
	    
	    // Método para actualizar la información del frame desde selectedVideoDialog
	    updateFrameInfoFromSelectedDialog(selectedDialog) {
	      if (selectedDialog) {
	       
	        
	        // Extraer valores de objetos reactivos de Vue

	        
	        // Extraer valores específicos
	        const similarity = selectedDialog.similarity;
	        const currentTime = selectedDialog.currentTime;
	        const bbox = selectedDialog.bbox;
	        const bbox_prob = selectedDialog.bbox_prob;
	        const faceId = selectedDialog.faceId;
	        const frame_idx = selectedDialog.frame_idx;
	        const id = selectedDialog.id;
	        const infovideo = selectedDialog.infovideo;
	        const path = selectedDialog.path;
	        const photo_uuid = selectedDialog.photo_uuid;
	        const timestamp = selectedDialog.timestamp;
	        const userId = selectedDialog.userId;
	        const uuid_user = selectedDialog.uuid_user;
	        const isVideoLoaded = selectedDialog.isVideoLoaded;
	        const framePhoto = selectedDialog.framePhoto;
			

	        
	        // Actualizar datos del frame actual
	        this.currentFrameData = {
	          bbox: bbox,
	          progress: this.progress,
	          bbox_prob: bbox_prob,
	          currentTime: currentTime,
	          faceId: faceId,
	          frame_idx: frame_idx,
	          id: id,
	          infovideo: infovideo,
	          path: path,
	          photo_uuid: photo_uuid,
	          similarity: similarity,
	          timestamp: timestamp,
	          userId: userId,
	          uuid_user: uuid_user,
	          isVideoLoaded: isVideoLoaded,
	          framePhoto: framePhoto,
	        };
	        
	        // Actualizar similitud y tiempo actual
	        if (similarity !== null && similarity !== undefined && !isNaN(similarity)) {
	          this.currentSimilarity = (similarity * 100).toFixed(2);
	        } else {
	          this.currentSimilarity = 'N/A';
	        }
	        
	        if (currentTime !== null && currentTime !== undefined && !isNaN(currentTime)) {
	          this.currentTime = this.formatTimeToMMSS(currentTime);
	        } else {
	          this.currentTime = 'N/A';
	        }
	        
	        // Actualizar imagen si está disponible
	        const croppedFacePhoto = selectedDialog.croppedFacePhoto;
	        if (croppedFacePhoto) {
	          if (this.currentImage) {
	            URL.revokeObjectURL(this.currentImage);
	          }
			  
	          this.currentImage = croppedFacePhoto;
	        }
	        
	        // Actualizar el tiempo del video
	        if (currentTime !== null && currentTime !== undefined && !isNaN(currentTime)) {
	          this.progress = currentTime;
	          this.currentTimeMS = currentTime;
	          const video = this.$refs.videoElement;
	          if (video) {
	            video.currentTime = currentTime;
	          }
	        }
	        
	        
	      }
	    },
	    
	    // Método para manejar clics en la gráfica
	    handleClick(event) {
	      // Obtener los elementos en el punto clicado
	      const elements = this.chart.getElementsAtEventForMode(
	        event,
	        "nearest", // Buscar el punto más cercano al clic
	        { intersect: true },
	        true
	      );

	      if (elements.length) {
	        const dataIndex = elements[0]._index;
	        
	        // Buscar el item correspondiente en facesSelected
	        if (this.infoToFilter?.selectedVideoDialog?.facesSelected && 
	            this.infoToFilter.selectedVideoDialog.facesSelected[dataIndex]) {
	          
	          const clickedItem = this.infoToFilter.selectedVideoDialog.facesSelected[dataIndex];
	          
	          // Actualizar el video al tiempo del punto clickeado
	          this.updateVideo(clickedItem.currentTime);
	          
	          // Actualizar la información del frame
	          this.updateFrameInfoFromSelectedDialog(clickedItem);
	          
	          
	        }
	      }
	    },

		}, //methods
	}
</script>
<style scoped>
.video-container {
  	position: relative;
	/*  width: 100%;*/
 	flex: 2;
	max-width:55vw; /* Ajusta el tamaño máximo si es necesario */
	height: auto;
	aspect-ratio: 16 / 9; /* Mantén el aspecto del video */
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
}

.info-column {
	display: flex;
	flex-direction: column;
	gap: 10px;
}

.video-element {
  width: 100%;
  height: 100%;
  display: block;
  pointer-events: none; 
  z-index: 1;
}
.video-element-1 {
  width: 100%;
  height: 100%;
  display: block;
 
}

.overlay-canvas {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none; /* Permite que los controles del video funcionen */
}
.video-controls {
/*  position: relative;*/
  width: 100%;
  margin-top: 10px;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;
/*  justify-content: center; */
  z-index: 11;
}
.play-btn {
  align-self: flex-start; /* Alinea el botón al principio */
}
.progress-bar {
  margin-top: 15px;
  flex: 1;
/*  display: flex;*/

/*  margin-top: 5px;*/
}
.overlay-canvas-draw-1 {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
/*  height: 100%;*/
  flex-shrink: 0; /* Evita que el canvas cambie de tamaño dinámicamente */
/*  height: auto; */
  pointer-events: auto; /* Permite que los controles del video funcionen */
  z-index: 5;
}

.chart-container {
  position: relative;
  width: 100%; /* Ancho ajustable */
  height: 150px; /* Cambia esta propiedad para ajustar la altura */
}
.chart-draw {
  position: relative;
  z-index: 3;
  max-width: 100%;
  width: 100%;
  height: 100%;
  display: block;
}

.content-linechart-video{
  width: 100%; /* Ancho ajustable */	
}
/*input[type="range"] {
  flex: 1;
}*/
</style>